const { makeStyles } = require("@material-ui/core");

export const cardChartStyle = makeStyles((theme) => ({
    card: {
        padding: "20px",
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        border: "1px solid #D0D5DD"
    },
}))